<script type="text/javascript">
    import Button,{ Label } from '@smui/button';
    import LoadState from "../../Enums/LoadState";
    import roundFloat from "../../Helpers/Misc/roundFloat";
    import StringHelper from "../../Helpers/StringHelper";
    import MapStore from "../../Map/Store";
    import ModalWindow from "../../UI/ModalWindow.svelte";
    import LocodeSelector from "../../UI/Ports/LocodeSelector.svelte";
    import PortsStore from "../../UI/Ports/Store";
    import LayerListSwitch from "../LayerList/LayerListSwitch.svelte";
    import SpireRoutingVesselType from "./SpireRoutingVesselType";
    import RoutingStore from "./Store";
    
    let visible = RoutingStore.meta.visible;
    let submit = () => {
        RoutingStore.actions.submit();
    };

    let vesselType = RoutingStore.query.vesselType;
    let vesselTypeOptions = Object.values(SpireRoutingVesselType);

	let startLocode = RoutingStore.query.startLocode;
	let startLocodePort = RoutingStore.query.startPort;
	let endLocode = RoutingStore.query.endLocode;
	let endLocodePort = RoutingStore.query.endPort;

	let canUseSuez = RoutingStore.query.canUseSuez;
	let canUsePanama = RoutingStore.query.canUsePanama;

    let state = RoutingStore.meta.queryState;
    let error = RoutingStore.meta.error;

    let geojson = RoutingStore.results.geojson;

    let ports = PortsStore.results.ports;
    
    
    let formReady = false;
    $: {
        formReady = $startLocodePort !== null && $endLocodePort !== null && $vesselType !== null;
    }

    let mapInitialised = MapStore.meta.initialised;
    let initialised = RoutingStore.meta.initialised;
    $: {
        if ($mapInitialised && $visible && !$initialised) {
            RoutingStore.actions.initMap();
        }
        if ($mapInitialised && !$visible && $initialised) {
            RoutingStore.actions.deinitMap(); 
        }
    };
</script>

<ModalWindow
	title={`Shipping Lanes - Routing`}
	hasCloseButton={true}
	hasBackground={false}
	resizable={true}
	draggable={true}
	fullscreen={false}
	padding={true}
	position="top-right"
	height="70%"
	bind:open={$visible}
    >

    <h2>Vessel Type:</h2>
    <select class='default' bind:value={$vesselType} style="width:100%;" disabled={$state === LoadState.LOADING}>
        <option value={0} selected={$vesselType === null}>Please select</option>
        {#each vesselTypeOptions as option}
            <option value={option} selected={$vesselType === option}>{option}</option>
        {/each}
    </select>

    
    <h2 style="margin-top:10px;">Start locode:</h2>
    <LocodeSelector input={startLocode} limit={5} bind:selected={startLocodePort} disabled={$state === LoadState.LOADING} />
    
    <h2>End locode:</h2>
    <LocodeSelector input={endLocode} limit={5} bind:selected={endLocodePort} disabled={$state === LoadState.LOADING}/>

    <h2>Options:</h2>
	<LayerListSwitch label={"Can use Suez Canal"} bind:checked={$canUseSuez} disabled={$state === LoadState.LOADING}/>
    <LayerListSwitch label={"Can use Panama Canal"} bind:checked={$canUsePanama} disabled={$state === LoadState.LOADING}/>

    {#if $error.length > 0}
        <div class="bg-error" style={"width:calc(100% - 20px); margin-top:10px; margin-bottom:10px; padding:10px; border-radius:3px;"}>
        {$error.trim()}{#if $error === "Unknown origin location" || $error === "Unknown destination location"}. Not all ports are supported.{/if}</div>
    {/if}

    <Button fullwidth color="primary" variant="unelevated" class="btn-add" on:click={()=>{ submit(); }} style="width:100%;margin-top:10px;" disabled={!formReady || $state === LoadState.LOADING}><Label>Submit</Label></Button>


    {#if $state === LoadState.LOADED}
        <hr style="margin-top:10px;margin-bottom:10px;"/>

        <h2 style="margin-top:10px;">Results:</h2>

        <p><b>Route time:</b> {StringHelper.formatDaysHoursAndMinutes($geojson.properties.duration / 60 / 60 / 24)}</p>
        <p><b>ETA:</b> {$geojson.properties.eta}</p>
        <p><b>Average Speed:</b> {roundFloat($geojson.properties.distance / ($geojson.properties.duration / 60 / 60), 2) } knots</p>

        
        <p><b>Distance:</b> {$geojson.properties.distance} nautical miles</p>
        <p><b>In SECA Zones:</b> {$geojson.properties.seca} nautical miles</p>
        
    {/if}

</ModalWindow>